import config from '../../../../config/index';

let typeHash = {
  "kinder":{
    studentType: 1,
    studentTypeName: '幼儿',
    studentTypeUpName: '幼儿园',
    studentTypeName2:'幼儿',
    sysName: '报名'
  },
  "school":{
    studentType: 1,
    studentTypeName: '幼儿',
    studentTypeUpName: '幼儿园',
    studentTypeName2:'幼儿',
    sysName: '报名'
  },
  "teacher":{
    studentType: 3,
    studentTypeName: '教师',
    studentTypeUpName: '教师招聘报名系统',
    studentTypeName2:'教师',
    sysName: '报名',
    sysName2: '预报名',
  },

};
export default {
  data() {
    return {
      // 配置文件获取当前区域和系统类型
      areaId: config.web.areaId,
      areaName: config.web.areaName,
      ...typeHash[config.web.systemLevel]
    };
  },
  created() {
    // 重写Message方法
    this.$message.loading = () => {};
    this.$message.hide = () => {};
  },
  watch: {},
  methods: {}
};
